import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { illustrationUrl } from '../../StudioBlankSlate';
import UploadBlankSlate from '../../_partials/UploadBlankSlate';
import SearchBlankSlate from '../SearchBlankSlate';
import { getIsSearchPage } from '../../../../selectors/studio';

const PUBLISHED_IMG_URL = illustrationUrl('studio-published-empty.png', 2);

const PublishedBlankSlate: FC<{}> = () => {
  const { t } = useTranslation();
  const isSearchPage = useSelector(getIsSearchPage);

  if (isSearchPage) {
    return <SearchBlankSlate />;
  }

  // on the "published" section, we don't want to allow uploads directly
  // and instead link to drafts studio with the submit modal on load.
  return (
    <UploadBlankSlate
      title={t('studio.blankSlate.published.title')}
      subtitle={t('studio.blankSlate.published.subtitle')}
      ctaLabel={t('studio.blankSlate.published.ctaLabel')}
      illustrationSrc={PUBLISHED_IMG_URL}
      linkToSubmit
      noBorder
    />
  );
};
PublishedBlankSlate.displayName = 'PublishedBlankSlate';

export default PublishedBlankSlate;
